module.exports = __webpack_public_path__ + "img/login-img@2x.b3532cae.png";